import { defaultListData, defaultListState } from 'bv-data'
import { getQuery } from 'bv-utils'
import type { IAccountCheckType } from '@/services/accountCheck/accountCheck'
import { getList } from '@/services/accountCheck/accountCheck'
import type { IAccountCheckingInfo } from '@/data/columns/accountCheck'
import { putSave } from '@/models/utils'
import type { ListModel, ListModelState } from '@/types'

export type IAccountCheckInfo = {

} & IAccountCheckingInfo

export type AccountCheckModelState = ListModelState<IAccountCheckInfo> & { id: number, type: IAccountCheckType};
export type AccountCheckListModel = ListModel<AccountCheckModelState, 'check'>

const listState: AccountCheckModelState = { ...defaultListState, id: 0, type: '' }


const AccountCheckModel: AccountCheckListModel = {
  namespace: 'check',
  state: listState,
  effects: {
    * list ({ params }, { call, put, select }) {
      const id: number = yield select((state: any) => state.check.id)
      const requestId = id + 1
      yield put(putSave({ id: requestId, type: params, loading: true }))
      const [ data, error ] = yield call(getList[params], getQuery())
      const currentId: number = yield select((state: any) => state.check.id)
      if (currentId === requestId) {
        yield put(putSave({  error,  data: data || defaultListData, loading: false }))
      }
    },
  },

  reducers: {
    clean (state) {
      return { ...state, ...defaultListState }
    },
    reset () {
      return listState
    },
    save (state, { payload = {} }) {
      return { ...state, ...payload }
    },
  },
}

export default AccountCheckModel
